export var FileUploadLimitations = {
    uploadLimitInBytes: 30000000,
    // tslint:disable-next-line:max-line-length
    supportedFileTypesForUpload: [
        '.jpeg',
        '.jpg',
        '.png',
        '.gif',
        '.ico',
        '.bmp',
        '.pdf',
        '.doc',
        '.docx',
        '.ppt',
        '.pptx',
        '.xls',
        '.xlsx',
        '.csv',
        '.tiff',
        '.xml',
        '.txt',
        '.log',
        '.wav',
        '.aif',
        '.aifc',
        '.aiff',
        '.mp3',
        '.mp4',
        '.mpga',
        '.mpg',
        '.mpa',
        '.gsd',
        '.gsm',
        '.au',
        '.snd',
    ]
};
//# sourceMappingURL=file-upload-limitations.js.map